import { useInternational } from '@/common/locale';
import { useStatInfoStore } from '@/common/stores/stat-info';
import { WidgetCommonArgument } from '@/dashboard/features/widgets/common/constants/define';
import { isEqual } from 'lodash-es';
import { computed, watch } from 'vue';
import { ArgumentInfo, WidgetVariable } from './variableListWindow/variable.types';
import { useWidgetSettingData } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/contexts/widgetSettingData';
import { useReferenceChartDataList } from './referenceSettingsOption.composables';

type ChartDataIndex = number;

export type ReferenceChartData = Omit<ArgumentInfo, 'argumentName'> & {
  chartDataIndex: ChartDataIndex;
  category: string;
};

export interface ReferenceVariable {
  key: ArgumentInfo;
  value: WidgetVariable | null;
}

export type ReferenceInfo = Record<ChartDataIndex, ReferenceVariable[] | undefined>;

export const CommonChartDataIndex = -1;
export const CommonStatId = '';
export const CommonCategory = '';

const setup = () => {
  const { t } = useInternational();
  const widgetSettingData = useWidgetSettingData();

  const { getStatInfo } = useStatInfoStore();

  const isSimpleMode = computed(() => widgetSettingData.chartOption?.settingsMode === 'simple');

  const { referenceChartDataList } = useReferenceChartDataList(
    computed(() =>
      isSimpleMode.value
        ? (widgetSettingData.chartData?.slice(0, 1) ?? [])
        : (widgetSettingData.chartData ?? []),
    ),
  );

  const updateVariables = (chartDataIndex: number, variables: ReferenceVariable[]) => {
    if (!widgetSettingData.chartOption) {
      return;
    }
    widgetSettingData.chartOption.referenceInfo = {
      ...widgetSettingData.chartOption.referenceInfo,
      [`${chartDataIndex}`]: variables,
    };
  };

  watch(
    () => widgetSettingData.chartType,
    (newChartType, oldChartType) => {
      if (!isEqual(WidgetCommonArgument[newChartType], WidgetCommonArgument[oldChartType])) {
        updateVariables(CommonChartDataIndex, []);
      }
    },
  );

  return {
    t,
    widgetSettingData,
    referenceChartDataList,
    getStatInfo,
    updateVariables,
  };
};

export default setup;
